import { render, staticRenderFns } from "./FormPrice.vue?vue&type=template&id=217767e0&scoped=true&"
import script from "./FormPrice.vue?vue&type=script&lang=ts&"
export * from "./FormPrice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217767e0",
  null
  
)

export default component.exports